export default {
    PENDING : 0,
    APPROVED: 1,
    UNAPPROVED: 2
}